import { render } from "./eVisaApproved.vue?vue&type=template&id=632a358c&scoped=true"
import script from "./eVisaApproved.vue?vue&type=script&lang=js"
export * from "./eVisaApproved.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=632a358c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a358c"]])

export default __exports__